import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackMainFrame').create(() => ({
  root: {
    position: 'relative',
    width: '90%',
    height: '96px',
    borderRadius: '12px',
    left: '24px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '12px',
      backgroundImage: 'url("https://storage.yandexcloud.net/gamed/cases-and-rewards/main-special-offer-bg.png")',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      opacity: 0.2,
      zIndex: 0,
    },
    zIndex: 1,
  },

  content: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
  },

  imageWrapper: {
    position: 'relative',
    top: '0',
    left: '0',
    width: '160px',
    aspectRatio: '1/1',
  },

  packImage: {
    position: 'absolute',
    height: '158px',
    left: '-24px',
    bottom: '24px',
  },

  discountContainer: {
    position: 'absolute',
    top: '12px',
    left: '64px',
    width: '72px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.6)',
    borderRadius: '20px',
    background: 'linear-gradient(180deg, #5EBEF0 0%, #0395FD 100%)',
    transform: 'rotate(-20deg)',
  },

  discountText: {
    fontWeight: 700,
    fontFamily: 'Space Grotesk',
    fontSize: '20px',
    color: 'white',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px',
  },

  offerTitle: {
    fontWeight: 700,
    fontFamily: 'Space Grotesk',
    fontSize: '24px',
    color: 'white',
    textAlign: 'center',
  },

  timeLeftWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
  },

  expiresText: {
    fontSize: '13px',
    fontWeight: 250,
    color: '#ccc',
  },

  timeLeftContainer: {
    display: 'flex',
    gap: '8px',
  },

  daysWrapper: {
    background: '#111',
    padding: '4px 6px',
    display: 'flex',
    borderRadius: '8px',
    boxShadow: 'inset 0px 1px 0px rgba(0, 0, 0, 1), inset 0px -1px 0px rgba(72, 72, 72, 1)',

    span: {
      fontWeight: 700,
      fontFamily: 'Space Grotesk',
      fontSize: '18px',
      color: 'white',
    },
  },
}))
